import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/services/globals';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { GuaranteeService } from 'src/app/services/guarantee.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  Button_Legal;
  button_GDPR;
  constructor(public translate: TranslateService, private globals: Globals,
    private characteristicService: CharacteristicService,
    private guaranteeService: GuaranteeService) { }

  ngOnInit() {
    this.characteristicService.getDefaultLanguage().subscribe((value) => {
        this.Button_Legal = this.translate.instant('Button_Legal_disclaimer');
        this.button_GDPR = this.translate.instant('button_GDPR');
    });
  }

}
